import Api from './ApiService'
// import ApiZoom from './ApiZoom'

export default {
    get(keyword, pageNumber, order) {
        return Api().get(`live_event?keyword=${keyword}&pageNumber=${pageNumber}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getOne(id) {
        return Api().get(`live_event/${id}`);
    },
    create(data) {
        return Api().post(`live_event`, data);
    },
    update(data) {
        return Api().put(`live_event/${data.id}`, data);
    }
}